import ApiService from '@/services/core/api.service'

const CustomerPurchaseData = {
  async get (query) {
    return ApiService.get(`agent/master-data/customer-purchases?${query}`)
  },

  async post (payload) {
    return ApiService.post('agent/master-data/customer-purchases', payload)
  },

  async put (payload) {
    return ApiService.put(`agent/master-data/customer-purchases/${payload.id}`, payload)
  }
}

export default CustomerPurchaseData
